import { Order } from '../../../../../interfaces/business';

export const reducerOrderId = (accumOrders: string[], { order_id }: Order) => {
  const copyAccumOrder = [...accumOrders];
  copyAccumOrder.push(order_id);
  return copyAccumOrder;
};

export const searchState = (allOrders: Order[], stateSearch: string) => allOrders.filter(({ state }: Order) => state.order_state_id === stateSearch);
